module.exports = __webpack_public_path__ + "img/img_hope04.0ee1921b.png";